import { useEffect, useState } from "react";

import { hasEmailWriterPollingSession } from "utilities/email-writer-polling-session";

/**
 * Reactive view of the email-writer polling session flag in sessionStorage.
 * Re-renders when `markEmailWriterPollingStarted` / `clearEmailWriterPollingSession` fire.
 */
export const useEmailWriterPollingSessionActive = (
  campaignId: string,
  clientId?: string,
): boolean => {
  const [isActive, setIsActive] = useState(() =>
    Boolean(campaignId && hasEmailWriterPollingSession(campaignId, clientId)),
  );

  useEffect(() => {
    const sync = () => {
      setIsActive(Boolean(campaignId && hasEmailWriterPollingSession(campaignId, clientId)));
    };

    sync();
    window.addEventListener("email-writer-polling-session-changed", sync);

    return () => {
      window.removeEventListener("email-writer-polling-session-changed", sync);
    };
  }, [campaignId, clientId]);

  return isActive;
};
